export enum ResetPasswordFomNames {
	email = 'email',
	currentPassword = 'currentPassword',
	newPassword = 'newPassword',
	confirmNewPassword = 'confirmNewPassword',
}
